import React from 'react';
import PropTypes from 'prop-types';
import { avatarUrl, formatDate, formatMapNames } from 'utils/Formatters';
import { withTranslation } from 'react-i18next';

class AccountPlayersPreviewRow extends React.Component {
  static propTypes = {
    accountId: PropTypes.number.isRequired,
    data: PropTypes.object.isRequired,
    onAccountPlayer: PropTypes.func.isRequired,
  }

  onAccountPlayer = (e) => {
    e.stopPropagation();
    const { data, onAccountPlayer } = this.props;
    onAccountPlayer(data.id);
  }

  render() {
    const { accountId, data, t } = this.props;
    const bg = { backgroundImage: avatarUrl(data) };
    return (
      <tr className='u-pointer' onClick={this.onAccountPlayer}>
        <td>{data.id}</td>
        <td>{data.name}</td>
        <td>{formatMapNames(data.cohorts)}</td>
        <td>{data.ageRange}</td>
        <td>{formatDate(data.createdAt)}</td>
        <td>{data.creator.id === accountId ? t('accountPlayersPreview.typeOwn') : t('accountPlayersPreview.typeCaregiver')}</td>
      </tr>
    );
  }
}

export default withTranslation()(AccountPlayersPreviewRow);
